(function () {
  document.documentElement.classList.add('ls-js');

  const loader = document.getElementById('LisansiumLoader');
  const skipLoader = document.documentElement.classList.contains('ls-skip-loader');
  let loaderDone = false;

  function hideLoader() {
    if (loaderDone || !loader) return;
    loaderDone = true;
    loader.classList.add('is-done');
    window.setTimeout(() => loader.remove(), 280);
  }

  if (loader) {
    if (skipLoader) {
      loader.remove();
    } else {
      const started = Date.now();
      const minVisible = 320;

      function dismissLoader() {
        const elapsed = Date.now() - started;
        const wait = Math.max(0, minVisible - elapsed);
        window.setTimeout(hideLoader, wait);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', dismissLoader, { once: true });
      } else {
        dismissLoader();
      }

      window.setTimeout(hideLoader, 900);

      try {
        sessionStorage.setItem('ls-loader-shown', '1');
      } catch (e) { }
    }
  }

  const header = document.querySelector('[data-lisansium-header]');
  if (header) {
    const toggle = header.querySelector('[data-mobile-toggle]');
    const drawer = header.querySelector('[data-mobile-drawer]');
    const closeBtn = header.querySelector('[data-mobile-close]');

    function openDrawer() {
      drawer?.classList.add('is-open');
      document.body.classList.add('ls-nav-open');
      toggle?.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      drawer?.classList.remove('is-open');
      document.body.classList.remove('ls-nav-open');
      toggle?.setAttribute('aria-expanded', 'false');
    }

    toggle?.addEventListener('click', openDrawer);
    closeBtn?.addEventListener('click', closeDrawer);
    drawer?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeDrawer));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer?.classList.contains('is-open')) closeDrawer();
    });

    window.addEventListener(
      'scroll',
      () => {
        header.classList.toggle('is-scrolled', window.scrollY > 8);
      },
      { passive: true }
    );
  }

  /* Search overlay */
  const searchModal = document.querySelector('[data-search-modal]');
  const searchOpeners = document.querySelectorAll('[data-search-open]');
  const searchInput = searchModal?.querySelector('[data-search-input]');
  const searchResults = searchModal?.querySelector('[data-search-results]');
  const SEARCH_ANIM_MS = 320;
  let searchTimer = null;
  let searchScrollHandler = null;
  let searchOutsideHandler = null;
  let searchClosing = false;

  function clearSearchResults(immediate) {
    if (!searchResults) return;
    searchResults.classList.remove('is-active');
    const finish = () => {
      searchResults.hidden = true;
      searchResults.innerHTML = '';
    };
    if (immediate) finish();
    else window.setTimeout(finish, SEARCH_ANIM_MS);
  }

  function openSearch() {
    if (!searchModal || searchClosing) return;
    searchModal.setAttribute('aria-hidden', 'false');
    searchModal.classList.remove('is-closing');
    searchModal.classList.add('is-open');
    document.body.classList.add('ls-search-open');
    clearSearchResults(true);
    window.setTimeout(() => searchInput?.focus(), 80);

    searchScrollHandler = () => {
      if (searchModal.classList.contains('is-open')) closeSearch();
    };
    window.addEventListener('scroll', searchScrollHandler, { passive: true });

    searchOutsideHandler = (e) => {
      if (!searchModal.classList.contains('is-open')) return;
      const inside = e.target.closest('.ls-search-modal__bar, .ls-search-modal__panel');
      if (!inside) closeSearch();
    };
    window.setTimeout(() => {
      document.addEventListener('mousedown', searchOutsideHandler);
    }, 0);
  }

  function closeSearch() {
    if (!searchModal || !searchModal.classList.contains('is-open') || searchClosing) return;
    searchClosing = true;
    searchModal.classList.add('is-closing');
    searchModal.classList.remove('is-open');
    document.body.classList.remove('ls-search-open');

    if (searchScrollHandler) {
      window.removeEventListener('scroll', searchScrollHandler);
      searchScrollHandler = null;
    }
    if (searchOutsideHandler) {
      document.removeEventListener('mousedown', searchOutsideHandler);
      searchOutsideHandler = null;
    }

    window.setTimeout(() => {
      searchModal.classList.remove('is-closing');
      searchModal.setAttribute('aria-hidden', 'true');
      clearSearchResults(true);
      if (searchInput) searchInput.value = '';
      searchClosing = false;
    }, SEARCH_ANIM_MS);
  }

  searchModal?.querySelector('.ls-search-modal__backdrop')?.addEventListener('click', closeSearch);

  function renderSearchResults(products) {
    if (!searchResults) return;
    searchResults.hidden = false;
    searchResults.classList.remove('is-active');

    if (!products.length) {
      searchResults.innerHTML = '<p class="ls-search-modal__empty">Sonuç bulunamadı.</p>';
    } else {
      searchResults.innerHTML = products
        .map(
          (p, i) => `
        <a href="${p.url}" class="ls-search-modal__item" style="--i:${i}">
          ${p.image ? `<img src="${p.image}" alt="" width="52" height="52" loading="lazy">` : ''}
          <span class="ls-search-modal__item-text">
            <strong>${p.title}</strong>
            <small>${p.price || ''}</small>
          </span>
        </a>`
        )
        .join('');
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        searchResults.classList.add('is-active');
      });
    });
  }

  function fetchSearchResults(query) {
    if (!query || query.length < 1) {
      clearSearchResults(false);
      return;
    }

    fetch(`${window.routes?.predictive_search_url || '/search/suggest'}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8&section_id=predictive-search`)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const items = [...doc.querySelectorAll('[data-product-url], .predictive-search__list-item a, .predictive-search__item')];
        if (items.length) {
          const products = items.slice(0, 8).map((el) => {
            const link = el.closest('a') || el;
            const img = link.querySelector('img');
            return {
              url: link.getAttribute('href') || '#',
              title: link.textContent?.trim() || '',
              image: img?.getAttribute('src') || '',
              price: link.querySelector('.price, .predictive-search__item-price')?.textContent?.trim() || '',
            };
          });
          renderSearchResults(products);
          return;
        }

        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`)
          .then((res) => res.json())
          .then((data) => {
            const products = (data.resources?.results?.products || []).map((p) => ({
              url: p.url,
              title: p.title,
              image: p.featured_image?.url || p.image || '',
              price: p.price ? `${p.price} ${window.Shopify?.currency?.active || ''}`.trim() : '',
            }));
            renderSearchResults(products);
          })
          .catch(() => renderSearchResults([]));
      })
      .catch(() => {
        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`)
          .then((res) => res.json())
          .then((data) => {
            const products = (data.resources?.results?.products || []).map((p) => ({
              url: p.url,
              title: p.title,
              image: p.featured_image?.url || '',
              price: '',
            }));
            renderSearchResults(products);
          })
          .catch(() => renderSearchResults([]));
      });
  }

  searchOpeners.forEach((btn) => btn.addEventListener('click', openSearch));
  searchModal?.querySelectorAll('[data-search-close]').forEach((el) =>
    el.addEventListener('click', (e) => {
      e.stopPropagation();
      closeSearch();
    })
  );

  searchInput?.addEventListener('input', (e) => {
    window.clearTimeout(searchTimer);
    searchTimer = window.setTimeout(() => fetchSearchResults(e.target.value.trim()), 180);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchModal?.classList.contains('is-open')) {
      e.preventDefault();
      closeSearch();
    }
  });

  /* PDP media slider */
  document.querySelectorAll('[data-pdp-media]').forEach((wrap) => {
    const count = parseInt(wrap.dataset.mediaCount || '1', 10);
    const sliderButtons = wrap.querySelector('.slider-buttons');
    if (!sliderButtons) return;

    sliderButtons.classList.add('ls-pdp-slider-nav');

    if (count <= 1) {
      wrap.classList.add('is-single-media');
      sliderButtons.querySelectorAll('.slider-button').forEach((btn) => {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
      });
      const current = sliderButtons.querySelector('.slider-counter--current');
      const total = sliderButtons.querySelector('.slider-counter--total');
      const sep = sliderButtons.querySelector('.slider-counter span[aria-hidden="true"]');
      if (current) current.textContent = '1';
      if (total) total.hidden = true;
      if (sep) sep.hidden = true;
    } else if (count > 1) {
      const total = sliderButtons.querySelector('.slider-counter--total');
      if (total) total.textContent = String(count);
    }
  });

  const revealItems = document.querySelectorAll('[data-reveal]');
  if (revealItems.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            entry.target.querySelectorAll('.ls-cat-tile, .ls-card, .ls-trust-item').forEach((child, i) => {
              child.style.setProperty('--reveal-delay', i * 70 + 'ms');
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -32px 0px' }
    );
    revealItems.forEach((el, i) => {
      el.style.setProperty('--reveal-delay', (i % 8) * 60 + 'ms');
      observer.observe(el);
    });
  }
})();
